// ======================================================================
// File Name       : serviceGroup
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import _ from 'lodash';
import { MODE } from '../constants';
import {
  SERVICE_GROUP_GET_SERVICE_GROUP_NAME,
  SERVICE_GROUP_INIT_EDITING,
  SERVICE_GROUP_RECEIVE_EDITING_GROUP,
  SERVICE_GROUP_RECEIVE_EDITING_SERVICE,
  SERVICE_GROUP_RECEIVE_EDITING_SUPERUSER,
  SERVICE_GROUP_RECEIVE_LIST,
  SERVICE_GROUP_RECEIVE_SEARCH_CONDITION_SUPERUSER,
  SERVICE_GROUP_RECEIVE_SEARCH_RESULT_SERVICE,
  SERVICE_GROUP_RECEIVE_SEARCH_RESULT_SUPERUSER,
  SERVICE_GROUP_RECEIVE_SERVICE_RELATION,
  SERVICE_GROUP_RECEIVE_SUPERUSER_RELATION,
  SERVICE_GROUP_RESET_DATA,
} from '../constants/ActionTypes';

const editingInitalState = {
  editingServiceGroup: { serviceGroupName: '' },
  editType: MODE.NEW_MODE,
  searchConditionService: {},
  searchResultService: {
    startPosition: 0,
    searched: false,
    recordNum: 0,
    byServiceCd: {},
    allServiceCds: [],
  },
  storedServiceSearchResult: {
    byServiceCd: {},
    allServiceCds: [],
  },
  searchConditionSuperUser: { superuserName: '', loginId: ''},
  searchResultSuperUser: {
    startPosition: 0,
    searched: false,
    recordNum: 0,
    bySecernId: {},
    allSecernIds: [],
  },
  storedSuperUserSearchResult: {
    bySecernId: {},
    allSecernIds: [],
  },
};
const INITIAL_STATE = {
  serviceGroupListInfo: {
    recordNum: 0,
    serviceGroupList: [],
    bySecernId: {},
  },
  ...editingInitalState,
  editingServiceGroupService: {},
  editingServiceGroupSuperUser: {},
  storedServiceGroupService: {},
  storedServiceGroupSuperUser: {},
  editSuccessful: false,
  detailServiceGroupService: {},
  detailServiceGroupSuperUser: {},
  detailServiceGroup: { serviceGroupName: '' },
  detailServiceGroupNameList: {}, // STEP10.0.0
};

export default function serviceGroup(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SERVICE_GROUP_RECEIVE_LIST: {
      const { recordNum, serviceGroupList } = action;
      const serviceGroupListInfo = serviceGroupList.reduce(
        (acc, cur) => {
          const { serviceGroupSecernId } = cur;
          acc.bySecernId[serviceGroupSecernId] = cur;
          return acc;
        },
        { bySecernId: {}, recordNum, serviceGroupList }
      );
      return {
        ...state,
        serviceGroupListInfo,
      };
    }

    case SERVICE_GROUP_RECEIVE_EDITING_GROUP: {
      const { payload } = action;
      return {
        ...state,
        editingServiceGroup: {
          ...state.editingServiceGroup,
          ...payload,
        },
      };
    }

    case SERVICE_GROUP_RECEIVE_SEARCH_RESULT_SERVICE: {
      const { serviceInfo } = action;
      const { recordNum, serviceList } = serviceInfo;
      const { storedServiceSearchResult } = state;
      const searchResultService = serviceList.reduce((acc, cur) => {
        const { serviceCd } = cur;
        acc.byServiceCd[serviceCd] = cur;
        acc.allServiceCds.push(serviceCd);
        if (!storedServiceSearchResult.byServiceCd[serviceCd]) {
          storedServiceSearchResult.byServiceCd[serviceCd] = cur;
        }
        if (storedServiceSearchResult.allServiceCds.indexOf(serviceCd) < 0) {
          storedServiceSearchResult.allServiceCds.push(serviceCd);
        }
        return acc;
      },
      { search: true, recordNum, byServiceCd: {}, allServiceCds: [] },
      );
      return {
        ...state,
        searchResultService,
        storedServiceSearchResult,
      }
    }

    case SERVICE_GROUP_RECEIVE_EDITING_SERVICE: {
      const { removedServiceCd, addedList, removedAll } = action;
      if (removedAll) {
        return {
          ...state,
          editingServiceGroupService: {},
        };
      }
      const editingServiceGroupService = { ...state.editingServiceGroupService};
      delete editingServiceGroupService[removedServiceCd];
      const serviceList = state.storedServiceSearchResult.byServiceCd;
      addedList.forEach((serviceCd, index) => {
        if (serviceList && serviceList[serviceCd]) {
          editingServiceGroupService[serviceCd] = serviceList[serviceCd];
          editingServiceGroupService[serviceCd].addNew = true;
          editingServiceGroupService[serviceCd].index = index;
        }
      });
      return {
        ...state,
        editingServiceGroupService,
      }
    }

    case SERVICE_GROUP_RECEIVE_SEARCH_RESULT_SUPERUSER: {
      const { startPosition, recordNum, superuserList } = action;
      const { storedSuperUserSearchResult } = state;
      const searchResultSuperUser = superuserList.reduce((acc, cur) => {
        const { superuserSecernId } = cur;
        acc.bySecernId[superuserSecernId] = cur;
        acc.allSecernIds.push(superuserSecernId);
        if (!storedSuperUserSearchResult.bySecernId[superuserSecernId]) {
          storedSuperUserSearchResult.bySecernId[superuserSecernId] = cur;
        }
        if (storedSuperUserSearchResult.allSecernIds.indexOf(superuserSecernId) < 0) {
          storedSuperUserSearchResult.allSecernIds.push(superuserSecernId);
        }
        return acc;
      },
        { startPosition, search: true, recordNum, bySecernId: {}, allSecernIds: [] },
      );

      return {
        ...state,
        searchResultSuperUser,
        storedSuperUserSearchResult,
      };
    }

    case SERVICE_GROUP_RECEIVE_EDITING_SUPERUSER: {
      const { removedSecern, addedList, removedAll } = action;
      if (removedAll) {
        return {
          ...state,
          editingServiceGroupSuperUser: {},
        };
      }
      const editingServiceGroupSuperUser = { ...state.editingServiceGroupSuperUser};
      delete editingServiceGroupSuperUser[removedSecern];
      const superUserList = state.storedSuperUserSearchResult.bySecernId;
      // add item into editing list
      const sortedEditingServiceGroupSuperUser = {};
      addedList.forEach((userSecernId, index) => {
        if (superUserList && superUserList[userSecernId]) {
          sortedEditingServiceGroupSuperUser[userSecernId] = superUserList[userSecernId];
          sortedEditingServiceGroupSuperUser[userSecernId].addNew = true;
          sortedEditingServiceGroupSuperUser[userSecernId].index = index;
        }
      });

      let editingIndex = Object.keys(sortedEditingServiceGroupSuperUser).length;
      Object.keys(editingServiceGroupSuperUser).map((userSecernId, _) => {
        if (!sortedEditingServiceGroupSuperUser[userSecernId]) {
          sortedEditingServiceGroupSuperUser[userSecernId] = editingServiceGroupSuperUser[userSecernId];
          sortedEditingServiceGroupSuperUser[userSecernId].index = editingIndex;
          editingIndex += 1;
        }
      });
      return {
        ...state,
        editingServiceGroupSuperUser: sortedEditingServiceGroupSuperUser,
      };
    }

    case SERVICE_GROUP_RECEIVE_SEARCH_CONDITION_SUPERUSER: {
      const { payload } = action;
      return {
        ...state,
        searchConditionSuperUser: {
          ...state.searchConditionSuperUser,
          ...payload,
        }
      };
    }

    case SERVICE_GROUP_RESET_DATA: {
      const editingServiceGroup = { serviceGroupName: '' };
      const editType = MODE.NEW_MODE;
      const editingServiceGroupService = {};
      const editingServiceGroupSuperUser = {};
      const storedServiceGroupService = {};
      const storedServiceGroupSuperUser = {};
      const editSuccessful = false;
      const detailServiceGroupService = {};
      const detailServiceGroupSuperUser = {};
      const detailServiceGroupNameList = {}; // STEP10.0.0
      return {
        ...state,
        ...editingInitalState,
        editingServiceGroup,
        editType,
        editingServiceGroupService,
        editingServiceGroupSuperUser,
        storedServiceGroupService,
        storedServiceGroupSuperUser,
        editSuccessful,
        detailServiceGroupService,
        detailServiceGroupSuperUser,
        detailServiceGroupNameList, // STEP10.0.0
      };
    }

    case SERVICE_GROUP_RECEIVE_SERVICE_RELATION: {
      const { serviceGroupRelationList} = action;
      const storedServiceGroupService = { ...state.storedServiceGroupService };
      const detailServiceGroupService = { ...state.detailServiceGroupService };
      const newEditingServiceGroupService = {};
      Object.keys(serviceGroupRelationList).map((key) => {
        const data = serviceGroupRelationList[key];
        const { serviceCd } = data.serviceInfo;
        newEditingServiceGroupService[serviceCd] = data.serviceInfo;
        storedServiceGroupService[serviceCd] = data.serviceInfo;
        detailServiceGroupService[serviceCd] = data.serviceInfo;
      });
      return {
        ...state,
        editingServiceGroupService: { ...newEditingServiceGroupService },
        storedServiceGroupService,
        detailServiceGroupService,
      };
    }

    case SERVICE_GROUP_RECEIVE_SUPERUSER_RELATION: {
      const { serviceGroupRelationList, recordNum } = action;
      const storedServiceGroupSuperUser = { ...state.storedServiceGroupSuperUser };
      const detailServiceGroupSuperUser = { ...state.detailServiceGroupSuperUser };
      const newEditingServiceGroupSuperUser = {};
      const detailServiceGroupNameList = {}; // STEP10.0.0

      Object.keys(serviceGroupRelationList).map((key) => {
        const data = serviceGroupRelationList[key];
        const { superuserSecernId } = data.superuserInfo;
        newEditingServiceGroupSuperUser[superuserSecernId] = data.superuserInfo;
        storedServiceGroupSuperUser[superuserSecernId] = data.superuserInfo;
        detailServiceGroupSuperUser[superuserSecernId] = data.superuserInfo;
        detailServiceGroupNameList[data.serviceGroupSecernId] = data.serviceGroupName; // STEP10.0.0
      });

      return {
        ...state,
        editingServiceGroupSuperUser: { ...newEditingServiceGroupSuperUser },
        storedServiceGroupSuperUser,
        detailServiceGroupSuperUser,
        superUserRelationNum: recordNum,
        detailServiceGroupNameList,//STEP10.0.0
      };
    }

    case SERVICE_GROUP_GET_SERVICE_GROUP_NAME: {
      const { serviceGroupListInfo } = state;
      const { serviceGroupSecernId } = action;
      const { serviceGroupName } = serviceGroupListInfo.bySecernId[serviceGroupSecernId];
      return {
        ...state,
        editingServiceGroup: {
          serviceGroupName,
        },
        detailServiceGroup: {
          serviceGroupName,
        }
      }
    }

    case SERVICE_GROUP_INIT_EDITING: {
      const { serviceGroupSecernId } = action;
      const { serviceGroupListInfo } = state;
      const { systemCreateFlag } = serviceGroupListInfo.bySecernId[serviceGroupSecernId];
      const newEditingServiceGroup = {
        ...state.editingServiceGroup,
        serviceGroupSecernId,
        systemCreateFlag, // Step 11.0.0
      };
      return {
        ...state,
        editingServiceGroup: newEditingServiceGroup,
        editType: serviceGroupSecernId ? MODE.EDIT_MODE : MODE.NEW_MODE,
      }
    }

    default:
      return state;
  }
}
